module.exports = __webpack_public_path__ + "img/nl-matching.5bc333f8.png";